import { createContext, useContext, useState, useMemo, useCallback } from "react";

const translations = {
  ru: {
    nav: {
      tour: "Тур",
      about: "О команде",
      videos: "Видео",
      gallery: "Галерея",
      press: "Пресса",
      contact: "Контакты",
      tickets: "Билеты",
      admin: "Админ",
      login: "Войти",
      register: "Регистрация",
      logout: "Выйти",
    },
    hero: {
      kicker: "THE WORLD TOUR · 2026",
      title1: "TEAM",
      title2: "ASTANA",
      subtitle:
        "Юмор нового поколения из Казахстана. Чемпионы Высшей лиги КВН. Мировой тур 2026 — Центральная Азия, Германия, США и Канада.",
      cta_primary: "КУПИТЬ БИЛЕТЫ",
      cta_secondary: "СМОТРЕТЬ РАСПИСАНИЕ",
      scroll: "Скролл",
      tagline: "Юмор нового поколения · Сделано в Казахстане",
    },
    tour: {
      kicker: "РАСПИСАНИЕ",
      title: "THE WORLD TOUR 2026",
      subtitle: "Kazakhstan • Europe • Canada • USA • Uzbekistan • Russia • Azerbaijan",
      filter_all: "Все",
      filter_kz: "Казахстан",
      filter_europe: "Европа",
      filter_us: "USA",
      filter_ca: "Canada",
      get_tickets: "БИЛЕТЫ",
      sold_out: "SOLD OUT",
      low: "ОСТАЛОСЬ МАЛО",
      doors: "Начало",
      tba: "TBA",
      tba_note: "Площадка и ссылка на билеты будут анонсированы",
      past_title: "АРХИВ",
      past_subtitle: "Концерты, которые уже прошли",
      past_badge: "ПРОШЁЛ",
      past_show_more: "ПОКАЗАТЬ ВСЕ",
      past_show_less: "СВЕРНУТЬ",
      past_more_count: "+ ещё",
    },
    about: {
      kicker: "О КОМАНДЕ",
      title: "TEAM ASTANA",
      tagline: "Юмор нового поколения из Казахстана.",
      lead:
        "Team Astana — современная юмористическая команда из Казахстана, созданная участниками легендарной команды КВН «Спарта» — чемпионов Высшей лиги КВН 2017 года.",
      paragraphs: [
        "Коллектив стал настоящим символом нового поколения казахстанского юмора, объединив в своем стиле харизму, интеллектуальную подачу, национальный колорит и мощную сценическую энергетику.",
        "После исторической победы в Высшей лиге КВН команда продолжила развитие уже как самостоятельный бренд — Team Astana. Сегодня коллектив успешно выступает на крупнейших сценах Казахстана и СНГ, участвует в телевизионных проектах, гастрольных турах и создает собственный entertainment-контент для многомиллионной аудитории.",
        "Team Astana — это не просто команда юмора. Это современный творческий бренд, представляющий Казахстан на большой сцене и формирующий новый уровень индустрии развлечений.",
      ],
      style_title: "СТИЛЬ",
      style: [
        "Харизматичная сценическая подача",
        "Современный интеллектуальный юмор",
        "Казахстанский колорит и узнаваемый стиль",
        "Импровизация и живое взаимодействие со зрителем",
        "Энергия большой сцены",
        "Юмор, понятный каждому",
      ],
      achievements_title: "ДОСТИЖЕНИЯ",
      achievements: [
        "Чемпионы Высшей лиги КВН 2017",
        "Первая команда из Казахстана, ставшая чемпионом Высшей лиги КВН",
        "Обладатели «Большого КиВиНа в золотом» на музыкальном фестивале «Голосящий КиВиН» в Светлогорске (2017)",
        "Обладатели Летнего кубка чемпионов КВН (2019)",
        "Вице-чемпионы Высшей лиги КВН (2016)",
        "Многократные финалисты и участники крупнейших телевизионных юмористических проектов СНГ",
        "Участники телевизионных шоу нового поколения, включая проект «Игра»",
        "Участники проекта «ЗВЁЗДЫ» — 3 сезона подряд",
        "Миллионы просмотров в социальных сетях и digital-платформах",
        "Гастрольные туры по Казахстану, России и странам СНГ",
        "Международные концерты в США, Канаде, Турции, Европе, Южной Корее и других странах",
        "Один из самых узнаваемых юмористических брендов Казахстана",
      ],
      members_title: "СОСТАВ",
    },
    videos: {
      kicker: "ВИДЕО",
      title: "СМОТРЕТЬ",
      subtitle: "Фрагменты выступлений, закулисье и трейлеры нового тура.",
    },
    gallery: {
      kicker: "ГАЛЕРЕЯ",
      title: "СО СЦЕНЫ",
      subtitle: "Фотограф — Zangar Skakov.",
    },
    press: {
      kicker: "ПРЕССА",
      title: "О НАС ГОВОРЯТ",
    },
    contact: {
      kicker: "СВЯЗАТЬСЯ",
      title: "БУКИНГ И ПРЕССА",
      subtitle:
        "Для запросов от площадок, агентств, СМИ и партнёров — заполните форму. Мы отвечаем в течение 48 часов.",
      name: "Ваше имя",
      email: "Email",
      organization: "Организация (необязательно)",
      city: "Город",
      type: "Тип запроса",
      types: {
        press: "СМИ / пресса",
        booking: "Букинг шоу",
        partnership: "Партнёрство",
        general: "Другое",
      },
      message: "Сообщение",
      submit: "ОТПРАВИТЬ",
      sending: "ОТПРАВЛЯЕМ...",
      success: "Спасибо! Мы свяжемся с вами в ближайшее время.",
      error: "Что-то пошло не так. Попробуйте ещё раз.",
    },
    newsletter: {
      title: "БУДЬ В КУРСЕ",
      subtitle: "Подпишись на анонсы новых дат тура и предпродажи билетов.",
      placeholder: "your@email.com",
      cta: "ПОДПИСАТЬСЯ",
      success: "Готово! Вы подписаны.",
    },
    footer: {
      rights: "Все права защищены.",
      built: "Team Astana · USA/Canada Tour 2026",
      photo: "Фото",
    },
    auth: {
      login_title: "ВХОД АДМИНА",
      register_title: "РЕГИСТРАЦИЯ АДМИНА",
      name: "Имя",
      email: "Email",
      password: "Пароль",
      login_btn: "ВОЙТИ",
      register_btn: "ЗАРЕГИСТРИРОВАТЬСЯ",
      to_register: "Нет аккаунта? Зарегистрироваться",
      to_login: "Уже есть аккаунт? Войти",
      register_pending: "Заявка отправлена. Дождитесь подтверждения супер-админа.",
      logging_in: "Входим...",
      registering: "Отправляем заявку...",
      home: "На главную",
    },
    admin: {
      title: "АДМИН-ПАНЕЛЬ",
      welcome: "Добро пожаловать",
      tabs: {
        overview: "Обзор",
        shows: "Тур",
        team: "Команда",
        bookings: "Заявки",
        newsletter: "Подписки",
        users: "Админы",
      },
      stats: {
        shows: "Шоу",
        team: "Участники",
        bookings: "Заявки",
        newsletter: "Подписки",
        users_pending: "Ожидают одобрения",
        users_total: "Всего админов",
      },
      shows: {
        add: "ДОБАВИТЬ ШОУ",
        edit: "Редактировать",
        delete: "Удалить",
        save: "Сохранить",
        cancel: "Отмена",
        confirm_delete: "Удалить шоу?",
        fields: {
          date: "Дата",
          time: "Время начала",
          city: "Город",
          country: "Страна",
          country_code: "Код страны (US/CA)",
          venue: "Площадка",
          venue_address: "Адрес",
          ticket_url: "Ссылка на билеты",
          status: "Статус",
        },
      },
      team: {
        add: "ДОБАВИТЬ УЧАСТНИКА",
        confirm_delete: "Удалить участника?",
      },
      users: {
        approve: "Одобрить",
        reject: "Отклонить",
        delete: "Удалить",
        confirm_delete: "Удалить администратора?",
        status: {
          pending: "Ожидает",
          approved: "Одобрен",
          rejected: "Отклонён",
        },
      },
      bookings: {
        empty: "Заявок пока нет.",
      },
      newsletter: {
        empty: "Подписок пока нет.",
      },
    },
  },
  en: {
    nav: {
      tour: "Tour",
      about: "About",
      videos: "Videos",
      gallery: "Gallery",
      press: "Press",
      contact: "Contact",
      tickets: "Tickets",
      admin: "Admin",
      login: "Log in",
      register: "Sign up",
      logout: "Log out",
    },
    hero: {
      kicker: "THE WORLD TOUR · 2026",
      title1: "TEAM",
      title2: "ASTANA",
      subtitle:
        "New-generation comedy from Kazakhstan. KVN Premier League champions. World Tour 2026 — Central Asia, Germany, USA & Canada.",
      cta_primary: "GET TICKETS",
      cta_secondary: "SEE THE DATES",
      scroll: "Scroll",
      tagline: "New-generation comedy · Made in Kazakhstan",
    },
    tour: {
      kicker: "DATES",
      title: "THE WORLD TOUR 2026",
      subtitle: "Kazakhstan • Europe • Canada • USA • Uzbekistan • Russia • Azerbaijan",
      filter_all: "All",
      filter_kz: "Kazakhstan",
      filter_europe: "Europe",
      filter_us: "USA",
      filter_ca: "Canada",
      get_tickets: "TICKETS",
      sold_out: "SOLD OUT",
      low: "LOW TICKETS",
      doors: "Show",
      tba: "TBA",
      tba_note: "Venue and ticket link coming soon",
      past_title: "ARCHIVE",
      past_subtitle: "Past shows",
      past_badge: "PAST",
      past_show_more: "SHOW ALL",
      past_show_less: "COLLAPSE",
      past_more_count: "+ more",
    },
    about: {
      kicker: "THE TEAM",
      title: "TEAM ASTANA",
      tagline: "New-generation comedy from Kazakhstan.",
      lead:
        "Team Astana is a modern comedy team from Kazakhstan, founded by the members of the legendary KVN team «Sparta» — KVN Premier League Champions 2017.",
      paragraphs: [
        "The collective became a true symbol of the new generation of Kazakh comedy, combining charisma, intellectual delivery, national flavor and powerful stage energy.",
        "After their historic victory in the KVN Premier League, the team continued to evolve as an independent brand — Team Astana. Today they perform on the biggest stages of Kazakhstan and the CIS, take part in TV shows, tours and create their own entertainment content for a multi-million audience.",
        "Team Astana is more than a comedy crew. It is a contemporary creative brand representing Kazakhstan on the big stage and shaping a new level of the entertainment industry.",
      ],
      style_title: "STYLE",
      style: [
        "Charismatic stage presence",
        "Modern intellectual humor",
        "Kazakh flavor and signature style",
        "Improvisation and live audience interaction",
        "Big-stage energy",
        "Humor everyone understands",
      ],
      achievements_title: "ACHIEVEMENTS",
      achievements: [
        "Champions of the KVN Premier League, 2017",
        "First team from Kazakhstan to win the KVN Premier League",
        "Big Golden KiViN — «Voicing KiViN» music festival, Svetlogorsk, 2017",
        "Winners of the KVN Summer Champions Cup, 2019",
        "Vice-Champions of the KVN Premier League, 2016",
        "Multi-time finalists of the biggest comedy TV shows across the CIS",
        "Cast members of new-generation TV shows, including «Igra»",
        "Cast members of «ZVYOZDY» — 3 consecutive seasons",
        "Millions of views on social media and digital platforms",
        "Tours across Kazakhstan, Russia and CIS countries",
        "International concerts in the USA, Canada, Turkey, Europe, South Korea and more",
        "One of the most recognizable comedy brands of Kazakhstan",
      ],
      members_title: "THE CREW",
    },
    videos: {
      kicker: "VIDEO",
      title: "WATCH",
      subtitle: "Show fragments, behind the scenes and trailers for the new tour.",
    },
    gallery: {
      kicker: "GALLERY",
      title: "FROM THE STAGE",
      subtitle: "Photographer — Zangar Skakov.",
    },
    press: {
      kicker: "PRESS",
      title: "WHAT THEY SAY",
    },
    contact: {
      kicker: "GET IN TOUCH",
      title: "BOOKING & PRESS",
      subtitle:
        "Venue owners, agencies, media and partners — fill the form below. We reply within 48 hours.",
      name: "Your name",
      email: "Email",
      organization: "Organization (optional)",
      city: "City",
      type: "Inquiry type",
      types: {
        press: "Media / Press",
        booking: "Show booking",
        partnership: "Partnership",
        general: "Other",
      },
      message: "Message",
      submit: "SEND",
      sending: "SENDING...",
      success: "Thanks! We'll get back to you shortly.",
      error: "Something went wrong. Try again.",
    },
    newsletter: {
      title: "STAY IN THE LOOP",
      subtitle: "Subscribe for new dates and presale alerts.",
      placeholder: "your@email.com",
      cta: "SUBSCRIBE",
      success: "Done! You're in.",
    },
    footer: {
      rights: "All rights reserved.",
      built: "Team Astana · USA/Canada Tour 2026",
      photo: "Photo",
    },
    auth: {
      login_title: "ADMIN LOGIN",
      register_title: "ADMIN SIGN UP",
      name: "Name",
      email: "Email",
      password: "Password",
      login_btn: "LOG IN",
      register_btn: "SIGN UP",
      to_register: "No account? Sign up",
      to_login: "Already have an account? Log in",
      register_pending: "Application sent. Wait for super-admin approval.",
      logging_in: "Logging in...",
      registering: "Sending...",
      home: "Back to site",
    },
    admin: {
      title: "ADMIN PANEL",
      welcome: "Welcome",
      tabs: {
        overview: "Overview",
        shows: "Tour",
        team: "Team",
        bookings: "Inquiries",
        newsletter: "Subscribers",
        users: "Admins",
      },
      stats: {
        shows: "Shows",
        team: "Members",
        bookings: "Inquiries",
        newsletter: "Subscribers",
        users_pending: "Pending approvals",
        users_total: "Total admins",
      },
      shows: {
        add: "ADD SHOW",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        confirm_delete: "Delete this show?",
        fields: {
          date: "Date",
          time: "Start time",
          city: "City",
          country: "Country",
          country_code: "Country code (US/CA)",
          venue: "Venue",
          venue_address: "Address",
          ticket_url: "Ticket URL",
          status: "Status",
        },
      },
      team: {
        add: "ADD MEMBER",
        confirm_delete: "Delete this member?",
      },
      users: {
        approve: "Approve",
        reject: "Reject",
        delete: "Delete",
        confirm_delete: "Delete this admin?",
        status: {
          pending: "Pending",
          approved: "Approved",
          rejected: "Rejected",
        },
      },
      bookings: {
        empty: "No inquiries yet.",
      },
      newsletter: {
        empty: "No subscribers yet.",
      },
    },
  },
};

const I18nContext = createContext({ lang: "ru", t: translations.ru, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem("astana_lang") : null;
    return saved === "en" || saved === "ru" ? saved : "ru";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") window.localStorage.setItem("astana_lang", next);
  }, []);

  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang, setLang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
